import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/gantt`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const ganttApi = {
  // Projets
  getProjets: () => api.get('/projets'),
  createProjet: (data) => api.post('/projets', data),
  updateProjet: (id, data) => api.put(`/projets/${id}`, data),
  deleteProjet: (id) => api.delete(`/projets/${id}`),
  getProjetFull: (id) => api.get(`/projets/${id}/full`),
  exportProjet: (id) => api.get(`/projets/${id}/export`),
  importProjet: (id, data) => api.post(`/projets/${id}/import`, data),

  // Phases
  createPhase: (data) => api.post('/phases', data),
  updatePhase: (id, data) => api.put(`/phases/${id}`, data),
  deletePhase: (id) => api.delete(`/phases/${id}`),

  // Actions
  createAction: (data) => api.post('/actions', data),
  updateAction: (id, data) => api.put(`/actions/${id}`, data),
  deleteAction: (id) => api.delete(`/actions/${id}`),

  // Tâches
  getTaches: (actionId) => api.get(`/actions/${actionId}/taches`),
  createTache: (data) => api.post('/taches', data),
  updateTache: (id, data) => api.put(`/taches/${id}`, data),
  deleteTache: (id) => api.delete(`/taches/${id}`),

  // Dépendances
  createDependance: (data) => api.post('/dependances', data),
  deleteDependance: (id) => api.delete(`/dependances/${id}`),

  // Risques
  getRisques: (projetId) => api.get(`/projets/${projetId}/risques`),
  createRisque: (data) => api.post('/risques', data),
  updateRisque: (id, data) => api.put(`/risques/${id}`, data),
  deleteRisque: (id) => api.delete(`/risques/${id}`),
};

export default ganttApi;
